import React, {useContext} from 'react'
import { useLocation } from "react-router-dom"
import moment from 'moment'
import queryString from 'query-string'
import Announces from "../../Components/Announces/Announces"
import { GET_ANNOUNCES } from "../../../graphql/index"
import { RELEVANT_INITIAL_FILTER } from "../../../constant"
import css from '../../Layout/Layout.module.scss'
import {FilterContext} from "../../../context";

const Main = () => {
	const { filter } = useContext(FilterContext)
	const location = useLocation()
	const params = queryString.parse(location.search)
	const fd = moment(params.fd).isValid() && params.fd ? moment(params.fd).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
	const td = moment(params.td).isValid() && params.td ? moment(params.td).format('YYYY-MM-DD') : null

	return (
		<>
			<div className={css.content}>
				<Announces
					title={"Самое важное"}
					tooltip="Самые главные события дня в стране и мире"
					variables={{...RELEVANT_INITIAL_FILTER,...filter,...{fd:fd, td:td, limit:20}}}
					query={GET_ANNOUNCES}
					limit={20}
					buttonMore={true}
				/>
			</div>
			<div className={css.sidebar}/>
		</>
	)
}
export default Main